import { TRIAGE_COMPLETION_PHRASES } from '../constants';

const escapeRegularExpression = (value: string): string =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const completionAlternatives: string = TRIAGE_COMPLETION_PHRASES.map((phrase: string): string =>
  phrase.trim().split(/\s+/).map(escapeRegularExpression).join('\\s+'),
).join('|');

const TRIAGE_COMPLETION_PATTERN: RegExp = new RegExp(
  `(?:^|[^A-Za-z0-9])(?:${completionAlternatives})(?=$|[^A-Za-z0-9])`,
  'i',
);

/** Returns true when a standalone completion statement appears in a Triage note. */
export function noteIndicatesCompletion(note: string): boolean {
  return TRIAGE_COMPLETION_PATTERN.test(note);
}
